
import { AddAutoPlantoConcept } from "@/core/services/store/concept.module";
import { AutoBerthPlanPlot } from "@/core/services/store/concept.module";
import { PreviewBerthPlanPlot } from "@/core/services/store/concept.module";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  inject: ["showErrors", "showSuccess", "showWarning", "isStandalone"],
  props: [
    "autoPlanningListModel",
    "fncCreateAutoPlanningListCallBack",
    "planType",
    "allowReplan",
    "planStartDate",
    "planEndDate"
  ],

  data() {
    return {
      msg: "Please Wait ...",
      loading: false,
      standalone: this.isStandalone,
      fields: [
        // { key: "itemSelected", sortable: false, label: "" },
        { key: "planId", sortable: false, label: "#" },
        { key: "title", sortable: false },
        { key: "totalLeeway", sortable: false, class: "text-center" },
        { key: "leewaySTD", sortable: false, class: "text-center" },
        { key: "ranking", sortable: false, class: "text-center" },
        // { key: "totalPlan", sortable: false },
        { key: "PlotPreview", sortable: false, class: "text-center" },
        { key: "Plan(s)", sortable: false, class: "text-center" },
      ],
      planFields: [
        { key: "vesselName", sortable: false, label: "Vessel" },
        {
          key: "startDate",
          sortable: false,
          label: "StartTime",
          class: "text-center",
        },
        {
          key: "endDate",
          sortable: false,
          label: "EndTime",
          class: "text-center",
        },
        {
          key: "voyageIn",
          sortable: false,
          label: "Voyage (In/Out)",
          thStyle: { width: "20%" },
        },
        {
          key: "startBollard",
          sortable: false,
          label: "Start Bollard",
          class: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "endBollard",
          sortable: false,
          label: "End Bollard",
          class: "text-center",
        },
        {
          key: "startPosition",
          sortable: false,
          label: "Start-End(Pos)",
          class: "text-center",
          thStyle: { width: "15%" },
        },
        // { key: "endPosition", sortable: false, label: "End Position" },
        {
          key: "leeway",
          sortable: false,
          label: "Leeway",
          class: "text-center",
        },
        {
          key: "hasPlan",
          sortable: false,
          label: "Plan",
          class: "text-center",
        },
      ],
      modalShowPlanList: false,
      modalShowPlotPlanningPreview: false,
      PlotPlanningPreview: "",
      plans: null,
      ItemSelectAll: true,
    };
  },
  computed: {
    ...mapGetters([
      "AddAutoPlantoConcept",
      "getConceptChartErrors",
      "getConceptChartMessages",
      "getAddAutoPlantoConceptResultConceptNames",
      "getAddAutoPlantoConcept",
      "AutoBerthPlanPlot",
      "PreviewBerthPlanPlot",
      "get_AutoBerthPlanPlot",
       "getCurrentLocale"
    ]),
  },
  mounted() {},
  methods: {
    ShowPlans(row) {
      this.modalShowPlanList = true;
      // alert(row.item.id);
      //debugger;
      var model = this.autoPlanningListModel.find(
        (r) => r.planId === row.item.planId
      );
      model.currentLocale = this.getCurrentLocale;

      this.plans = model.plans;
    },
    ShowPlotPlanningPreview(row) {
      this.loading = true;
      var model = this.autoPlanningListModel.find(
        (r) => r.planId === row.item.planId
      );
      model.currentLocale = this.getCurrentLocale;
      model.PlanStartDate = moment(this.planStartDate).format("YYYY-MM-DDTHH:mm:ss");
      model.PlanEndDate = moment(this.planEndDate).format("YYYY-MM-DDTHH:mm:ss");

      this.$store.dispatch(AutoBerthPlanPlot, model).then(() => {
        const errors = this.getConceptChartErrors;
        this.loading = false;
        if (errors.length > 0) {
          this.showErrors(errors);
          this.loading = false;
        } else {
          this.loading = false;

          this.modalShowPlotPlanningPreview = true;
          this.PlotPlanningPreview =
            "data:image/png;base64," + this.get_AutoBerthPlanPlot.image;
          /* const result = this.getAddAutoPlantoConcept;
          const conceptNames = this.getAddAutoPlantoConceptResultConceptNames;
          this.fncCreateAutoPlanningListCallBack(result, conceptNames); */
        }
      });
    },
    GenerateConcept() {
      var model = this.autoPlanningListModel.filter(
        (r) => r.itemSelected === true
      );

      if (model.length == 0) {
        this.showWarning([
          {
            messageText: "plan not selected",
          },
        ]);
        return false;
      }

      // try {
      //   var model20 = model.filter(
      //     (r) => r.plans.filter((k) => k.hasPlan == true).length > 0
      //   );
      //   alert(model20);
      // } catch (err) {
      //   alert(err.message);
      // }

      var model2 = model.filter(
        (r) => r.plans.filter((k) => k.hasPlan == true).length > 0
      );

      if (model2.length == 0) {
        this.showWarning([
          {
            messageText: "there is no plan",
          },
        ]);
        return false;
      }
      this.loading = true;

      this.$store.dispatch(AddAutoPlantoConcept, model2).then(() => {
        const errors = this.getConceptChartErrors;
        this.loading = false;
        if (errors.length > 0) {
          this.showErrors(errors);
        } else {
          const result = this.getAddAutoPlantoConcept;
          const conceptNames = this.getAddAutoPlantoConceptResultConceptNames;
          this.fncCreateAutoPlanningListCallBack(result, conceptNames);
        }
      });
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD HH:MM");
    },
    printPlotImage() {
      const img = this.$refs.plotImage;
      if (img instanceof HTMLImageElement) {
        // Safe to use img.src, etc.
        console.log(img.src);
        const win = window.open("", "_blank");
        if (!win) return;
        win.document.write(`
      <html>
        <head>
          <title>Print Plot</title>
          <style>
            @media print {
              @page {
                size: A4 landscape;
                margin: 5mm;
              }
              body {
                margin: 5mm;
              }
              img {
                width: 100%;
                height: auto;
              }
            }
          </style>
        </head>
        <body>
          <img id="print-img" src="${img.src}" />
          <script>
            const image = document.getElementById('print-img');
            image.onload = function() {
              window.print();
              window.close();
            };
          <\/script>
        </body>
      </html>
    `);
        win?.document.close();
      }
    },
  },
  watch: {
    ItemSelectAll: function(val) {
      this.autoPlanningListModel.map((r) => (r.itemSelected = val));
    },
  },
};
